
import { Location } from '@angular/common';
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { ApiGateway, Breed, PageOptions } from 'cw-backend';
import { CwUtils } from 'cw-utils';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class BreedListProvider implements Resolve<any> {
    breed: Breed[];
    breedEdit: Breed;
    onDataChanged: BehaviorSubject<any>;
    routeParams: any;
    state: any;
    pageOptions: PageOptions;
    currentPage: PageOptions;

    constructor(
        public gw: ApiGateway,
        private location: Location,
    ) {
        this.onDataChanged = new BehaviorSubject({});
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        // Get state for current or new page
        this.state = this.location.getState();
        if (this.state?.currentPage && state.url.includes(this.state?.path)) {
            this.currentPage = this.state?.currentPage;
        }
        this.breedEdit = this.state?.currentBreed;

        if (this.currentPage) {
            this.pageOptions = this.currentPage;
        }
        else {
            this.pageOptions = new PageOptions();
            this.pageOptions.fieldSort = 'name';
        }
        return new Promise<void>((resolve, reject) => {
            Promise.all([
                this.getPage(this.pageOptions)
            ]).then(
                () => {
                    resolve();
                },
                reject
            );
        });
    }

    get(id: number): Observable<Breed> {
        if (!id) {
            return null;
        }
        return this.gw.get('breed/:id', { id: id });
    }

    get currentBreed(): Breed {
        return this.breedEdit;
    }

    getAll(entity?: String): Promise<any> {
        let urlPath = 'breed/';
        if (entity) {
            urlPath = entity + urlPath
        }
        return new Promise((resolve, reject) => {
            this.gw.get(urlPath).subscribe((res: HttpResponse<any>) => {
                this.breed = res.body;
                this.onDataChanged.next(this.breed);
                resolve(res);
            }, reject);
        });
    }

    getPage(pageOptions: PageOptions): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('breed/search', pageOptions).subscribe((res: HttpResponse<any>) => {
                if (!CwUtils.compare(this.breed, res.body.content) && res.body.content.length > 0) {
                    this.breed = res.body.content;
                    this.onDataChanged.next(this.breed);
                }
                else {
                    this.breed = res.body.content;
                };
                resolve(res);
            }, reject);
        });
    }

    getPageSettings() {
        if (this.currentPage) {
            return this.pageOptions;
        } else {
            return;
        }
    }
}

